const SubSection = ({title, children}) => <div className="bf-dashboard-subsection">
  <div className="bf-dashboard-subsection-title">
    {title}
  </div>
  <div className="bf-dashboard-subsection-items">
    {children}
  </div>
</div>;

export default SubSection;